import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
interface Props {
  experiencesCount: number;
}

const Experiences: React.FC<Props> = ({ experiencesCount }) => {
  return (
    <div
      className={clsx(
        'border-solid border-1   border-gray-200 rounded',
        'mr-4 mb-2 max-w-fit bg-gray-10 px-4 py-3 text-gray-700 ',
      )}
    >
      <p className="text-xs">
        <T kind="Programs" />
      </p>
      <p className="mt-2 text-2xl font-semibold">
        {when(experiencesCount != 0, experiencesCount)
          .map<string>(String)
          .getOrElse(() => '--')}
      </p>
    </div>
  );
};

export default observer(Experiences);
